export const OPERATORS = {
  IS_ANY_OF: 1,
  IS_KNOWN: 2,
  IS_NONE_OF: 3,
  IS_UNKNOWN: 4
}
